<button
  type="button"
  role="switch"
  [attr.aria-checked]="checked"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-labelledby]="ariaLabelledBy()"
  [attr.aria-describedby]="ariaDescribedBy()"
  [attr.id]="id()"
  [attr.name]="name()"
  [disabled]="isDisabled"
  [class]="trackClasses()"
  (click)="toggle()"
  (keydown)="onKeyDown($event)">
  <span [class]="thumbClasses()"></span>
</button>
